module.exports = __webpack_public_path__ + "static/media/paso_a_paso_home.8fd0aec2.png";